import * as storage from '../../utils/storage';

const KEY = 'PLAYER_SETTINGS';
const persisted = storage.load(KEY);

// Initial state
const state = {
  license: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiV2ViIiwidXJscyI6WyJjYXN0bGFicy5jb20iLCJjYXN0bGFicy1jaHJvbWVjYXN0LnMzLWV1LXdlc3QtMS5hbWF6b25hd3MuY29tIiwiY2xwcC5zMy1ldS13ZXN0LTEuYW1hem9uYXdzLmNvbSIsImxvY2FsaG9zdCIsIjEyNy4wLjAuMSJdLCJraWQiOjQ0MX0.Awa33txsCNArKMZ6cL4ESs90BNmHJ4l3rbTXNJnjgwtmqgVaoDF_C7W7nBiheuH7zBEePHoinr7f3jpld50mQ10yhLWoCFgvOu-qNCcI5jReXAsnspaHwMPONTp3STDTgPEulNOnsNBMyJnmPN0ftbSQhbvTK52yshp0NI11e15TSNAhm1bHB5kjzNAcBj98xR0nzSIAmuxvYLs9HJhlb-cNMb1wB82faD2jR6iPjQK1Jjw5MjxqnxEr5wJ9LFv0Jax0VNqwsu46-3PkMft2rrFMlLYLrl9QZNa-tQCDdFMm-9I6IUhO6jYtzkcuCnnB6NtMtfMrMpaEcaZgOpUm_g',
  autoHideUi: true,
};

// getters
const getters = {
};

// actions
const actions = {
};

// mutations
const mutations = {
};

function addState (name, defautlValue) {
  state[name] = persisted && persisted[name] !== undefined ? persisted[name] : defautlValue;
  mutations[name] = (state, value) => {
    state[name] = value;
    storage.persist(KEY, state);
  };
}

addState('showConfig', true);
addState('showJson', true);
addState('showPlayer', true);
addState('showBufferInfo', true);
addState('showBufferPlot', true);
addState('showAbrPlots', true);
addState('showStats', true);
addState('showEvents', true);
addState('showState', true);
addState('showPlots', true);
addState('showLogs', true);
addState('autoHideUi', true);
addState('playsInline', true);

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
